'use strict';

var selectedContacts = [];
var allContactData = {};

function createContactsObject(contacts) {
    // user / email info
    for (var i = 0; i < contacts.length; i++) {
        var contact = contacts[i];
        if (contact.name) {
            allContactData[contact.email] = {
                name: contact.name,
            };
        } else {
            allContactData[contact.email] = {
                name: '',
            };
        }
    }
}

$(window).on('load', function () {
    if (document.getElementById('add-contacts')) {
        document
            .getElementById('add-contacts')
            .addEventListener('keyup', addContacts);
    }
    if (document.getElementById('invite-submit')) {
        document
            .getElementById('invite-submit')
            .addEventListener('click', getDataAndSend);
    }

    //   copy to clipboard code
    if (document.getElementsByClassName('copy-btn')[0]) {
        var clipboard = new ClipboardJS('.copy-btn');
        clipboard.on('success', function (e) {
            document.getElementsByClassName('copy-btn')[0].innerText =
                'Copied!';
        });

        clipboard.on('error', function (e) {
            alert('Copy failed. Please highlight and copy the link');
        });
    }
});

function getDataAndSend() {
    var addButton = document.getElementById('tfa_24-wfDL');
    var submit = document.getElementById('invite-submit');
    document.getElementById('tfa_9').value =
        document.getElementById('fullname').value;
    document.getElementById('tfa_1').value =
        document.getElementById('useremail').value;
    checkForRemainingInput();
    if (
        document.getElementById('tfa_9').value !== '' &&
        validateEmail(document.getElementById('tfa_1').value)
    ) {
        if (selectedContacts.length > 0) {
            if (selectedContacts.length > 1) {
                for (var i = 0; i < selectedContacts.length; i++) {
                    var contact = selectedContacts[i];

                    if (i == 0) {
                        document.getElementById('tfa_18').value = contact.name;
                        document.getElementById('tfa_21').value = contact.email;
                    } else {
                        document.getElementById('tfa_18[' + i + ']').value =
                            contact.name;
                        document.getElementById('tfa_21[' + i + ']').value =
                            contact.email;
                    }
                    if (i !== selectedContacts.length - 1) {
                        addButton.click();
                    }
                }
            } else {
                document.getElementById('tfa_18').value =
                    selectedContacts[0].name;
                document.getElementById('tfa_21').value =
                    selectedContacts[0].email;
            }
            submit.click();
        }
    } else {
        //   submit.click();
        if (!document.getElementById('fullname').value) {
            document.getElementById('fullname').style.border = '2px solid red';
        } else {
            document.getElementById('fullname').style.border =
                '1px solid #8f8f8f';
        }
        if (!validateEmail(document.getElementById('useremail').value)) {
            document.getElementById('useremail').style.border = '2px solid red';
        } else {
            document.getElementById('fullname').style.border =
                '1px solid #8f8f8f';
        }
    }
}

function pushAndAppendEmail(email) {
    $('.typed-contacts').append(
        '<span class="contact ' + email + '">' + email + '</span>'
    );
    selectedContacts.push(
        (allContactData[email] = {
            email: email,
            name: '',
        })
    );
    document.getElementById('add-contacts').value = '';

    $('.contact').each(function (index) {
        $(this).on('click', removeEmail);
    });
}

function addContacts(event) {
    checkForEmail(event);
}

function validateEmail(email) {
    var re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function cleanInput(email) {
    return email.replace(/\,|\s+/g, '');
}

function checkForRemainingInput() {
    if (document.getElementById('add-contacts').value !== '') {
        var inputVal = cleanInput(
            document.getElementById('add-contacts').value
        );
        if (validateEmail(inputVal)) {
            pushAndAppendEmail(inputVal);
        }
    }
}

function checkForEmail(event) {
    var inputVal = document.getElementById('add-contacts').value;
    if (event.keyCode === 188 || event.keyCode === 32) {
        inputVal = cleanInput(inputVal);
        if (validateEmail(inputVal)) {
            pushAndAppendEmail(inputVal);
        }
    }
    if (event.keyCode === 13) {
        if (validateEmail(inputVal)) {
            pushAndAppendEmail(inputVal);
        }
    }
    if (selectedContacts.length > 0) {
        document.getElementsByClassName('to-row')[0].style.display = 'flex';
    } else {
        document.getElementsByClassName('to-row')[0].style.display = 'none';
    }
}

function removeEmail(event) {
    for (var i = 0; i < selectedContacts.length; i++) {
        var contact = selectedContacts[i];

        if (contact.email == event.target.classList[1]) {
            selectedContacts.splice(i, 1);
            event.target.remove();
        }
    }
    if (!selectedContacts) {
        document.getElementsByClassName('to-row')[0].style.display = 'none';
    }
}

function appendContactsToInput() {
    var input = docdocument.getElementById('add-contacts');

    for (var i = 0; i < selectedContacts.length; i++) {
        var contact = selectedContacts[i];

        input.children.push('<div class="contact">' + contact.email + '</div>');
    }
}
